import React, {Component} from "react";
import CommToolContext from "../common/comm_tool_context";
import  IPSTeam from "./Team/ipsteam"
import {withRouter} from "react-router-dom";
import ExitButton from "../../components/ExitButton";

class IPSProjectTeam extends Component {
    render() {
        return (
            <CommToolContext.Consumer>
                {context => (
                    <div className="container-fluid">
                        <div>
                            <IPSTeam project={this.props.project}
                                  context={context}
                                  status={this.props.status}
                               
                                  
                                  />
                        </div>
                    </div>
                )}
            </CommToolContext.Consumer>
        );
    }
}

// IPSProjectTeam.contextType = CommToolContext;
export default withRouter(IPSProjectTeam);
